import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../common/queryClient/getMutationFn';
import { apiClient } from '../../common/ApiClient';
import { OutputDataUrl } from './OutputDataUrl';
import { ConfirmOutputDataType } from '../schema/types';

const postConfirmOutputData = async (
  params: ConfirmOutputDataType,
  headers?: HttpHeaders,
) =>
  apiClient
    .post<void>(
      OutputDataUrl.OUTPUT_DATA_CONFIRMATIONS,
      params,
      headers ? { headers } : undefined,
    )
    .then((response) => response.data);

export const useConfirmOutputData = createApiMutationHook(
  ['confirmOutputData'],
  getMutationFn(postConfirmOutputData),
);
